export function App() {
  return null;
}

App.displayName = 'ProfileApp';
